import { Box, Drawer } from "@mui/material";
import React from "react";
import { BrowseHome } from "./BrowseHome";
import { CollectionsAZ } from "./CollectionsAZ";
import { useMobile } from "../../hooks/useMobile";
import { useHomeStyles } from "./Home.style";
import { BrowseProvider } from "./contexts/browse.context";

export const ExploreScreen = (): JSX.Element => {
    const { isMobile, isTablet } = useMobile();

    const classes = useHomeStyles();

    return (
        <BrowseProvider>
            <Box display={"flex"} p={!isTablet && isMobile ? 2 : 4} width={1}>
                <Box width={1} sx={{ minWidth: 0 }}>
                    {!isTablet && isMobile && <div className={classes.toolbar} />}
                    <BrowseHome />
                </Box>

                {/* CollectionsAZ sidebar - hidden on all screen sizes per original logic */}
                <Box sx={{ display: "none" }}>
                    <Drawer
                        className={classes.homeDrawer}
                        variant="permanent"
                        classes={{ paper: classes.homeDrawerPaper }}
                        anchor="right"
                    >
                        <CollectionsAZ />
                    </Drawer>
                </Box>
            </Box>
        </BrowseProvider>
    );
};
